import React from 'react';
import Section from './section';
import i18n from 'i18next';
import { trackFootfallEvent } from 'src/utils/analytics';
import footfallEventTypes from 'src/constants/footfallEventTypes';

const quotes = [
  {
    quote: i18n.t('HealthUnlocked changed my life, I am now more informed on how to better manage my condition, and I know I am not alone.'),
    type: 'app-store',
  },
  {
    quote: i18n.t('Excellent information, someone always ready to help you if you have a problem gives me peace of mind and less trips to the GP.'),
    type: 'user-survey',
  },
  {
    quote: i18n.t('There’s so much support and guidance on here, you feel as though you have your own coach. I was sceptical, but here I am, 50 years old, overweight and about to run 25 minutes without stopping.'),
    type: 'app-store',
  },
  {
    quote: i18n.t('The fact that you can find others with similar challenges and their suggestions as to how to overcome them is invaluable!'),
    type: 'user-survey',
  },
  {
    quote: i18n.t('As a carer it’s good to be able to relate to people who are in the same situation and have an idea of stages that our loved ones are going through.'),
    type: 'user-survey',
  },
];

class UserQuotesSection extends React.Component {
  state = {
    currentQuote: 0,
  }

  componentDidMount = () => {
    setInterval(() => {
      this.onForwardClick();
    }, 10000);
  }

  onBackClick = () => {
    const nextQuoteIndex = this.state.currentQuote - 1;
    this.setState({
      currentQuote: nextQuoteIndex < 0
        ? (quotes.length - 1)
        : nextQuoteIndex,
    });
  }

  onForwardClick = () => {
    const nextQuoteIndex = this.state.currentQuote + 1;
    this.setState({
      currentQuote: nextQuoteIndex > (quotes.length - 1)
        ? 0
        : nextQuoteIndex,
    });
  }

  render() {
    return (
      <Section className="home__user-quotes">
        <div>
          <span className="icon icon-back-arrow" onClick={this.onBackClick} />
        </div>
        <div className="home__user-quotes__content">
          <div className="home__user-quotes__content__quote">
            “{quotes[this.state.currentQuote].quote}”
          </div>
          <div className="home__user-quotes__content__subtitle">
            {quotes[this.state.currentQuote].type === 'user-survey'
              ? (
                <React.Fragment>
                  <a
                    href="https://itunes.apple.com/app/apple-store/id1016950959?pt=1924360&ct=homepage&mt=8"
                    target="_blank"
                    onClick={() => {
                      trackFootfallEvent(footfallEventTypes.CLICKED, { clickMetadata: { section: 'userquote-appstore' }, clickType: 'visitor-homepage' });
                    }}
                  >
                    App store
                  </a> review, 2017
                </React.Fragment>
                )
              : (
                <a
                  href="https://assets.healthunlocked.com/campaign/HU-User-survey-results-US.pdf"
                  target="_blank"
                  onClick={() => {
                    trackFootfallEvent(footfallEventTypes.CLICKED, { clickMetadata: { section: 'userquote-testimonial' }, clickType: 'visitor-homepage' });
                  }}
                >
                  {i18n.t('User survey testimonial')}
                </a>
              )}
          </div>
        </div>
        <div>
          <span className="icon icon-forwards-arrow" onClick={this.onForwardClick} />
        </div>
      </Section>
    );
  }
}

export default UserQuotesSection;



// WEBPACK FOOTER //
// ./src/modules/home/components/userQuotesSection.js